export enum LocationType {
  GridSite = 'gridSite',
  GPSCoordinates = 'gpsCoordinates',
  LandingPlace = 'landingPlace',
}
